import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { UserRole } from "../../types/vtc";
import { AUTH_CONTENT, loginHref } from "../../data/auth";
import { getSession } from "../../lib/auth";

interface RequireAuthProps {
  role: UserRole;
  children: ReactNode;
}

/** Sends logged-out users to login, and the wrong role to their own dashboard. */
export default function RequireAuth({ role, children }: RequireAuthProps) {
  const session = getSession();

  if (!session) {
    return (
      <Navigate to={loginHref(role)} replace />
    );
  }
  if (session.role !== role) {
    return <Navigate to={AUTH_CONTENT[session.role].dashboardHref} replace />;
  }
  return children;
}
